var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"py-4"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('a',{attrs:{"target":_vm.data.target,"href":_vm.data.url}},[_c('img',{attrs:{"src":_vm.data.image.url,"title":_vm.data.image.title,"alt":_vm.data.image.alt,"loading":"lazy","width":"100%"}})])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }